import {
  color,
  Flex,
  Link,
  PrimaryButton,
  PrimaryText,
  spacing,
  StyleProps,
  typography,
  useColorMode,
  useIsMobileView,
} from 'deepstash-ui';
import useSource from 'providers/hooks/useSource';
import React from 'react';
import SectionTitle from 'src/components/layout/components/SectionTitle';
import SubsectionHeader from 'src/components/metacontent/components/SubsectionHeader';
import SourceCollapsedLarge from 'src/components/source/source-collapsed/SourceCollapsedLarge';
import SourceCollapsedMedium from 'src/components/source/source-collapsed/SourceCollapsedMedium';
import { GAP_SIZE_REM, SECTION_GAP_REM, slugify } from 'utils/global';
import { normalizeSource } from 'utils/normalizers/source';
import commonStrings from 'utils/strings/commonStrings';
import pageStrings from 'utils/strings/pageStrings';

const OtherTakesList: React.FC<StyleProps> = ({ ...props }) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  const { source, relatedPosts } = useSource();

  const sourceHref = React.useMemo(() => {
    return source?.seo?.source
      ? `/book/${source.seo?.source?.id}/${slugify(source.seo.source.title)}`
      : '';
  }, [source]);

  if (
    !relatedPosts?.same_source_articles ||
    relatedPosts.same_source_articles.length === 0 ||
    !source
  )
    return null;

  const sectionTitle =
    commonStrings.metacontent.differentPerspectives + ' ' + source?.title;

  return (
    <Flex flexDir="column" w="100%" {...props}>
      {isMobileView ? (
        <SubsectionHeader
          pt={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
          mb={spacing.toRem(16)}
          height="auto"
        >
          {sectionTitle}
        </SubsectionHeader>
      ) : (
        <SectionTitle
          pt={SECTION_GAP_REM}
          pb={spacing.toRem(16)}
          title={sectionTitle}
        />
      )}
      <PrimaryText
        {...typography.primaryTextFonts.medium.regular}
        color={color[colorMode].textSecondary}
        mb={spacing.M.rem}
      >
        {pageStrings.article.otherTakesDescription}
      </PrimaryText>

      <Link href={sourceHref}>
        <PrimaryButton
          mb={{ base: spacing.toRem(16), md: GAP_SIZE_REM }}
          h={spacing.toRem(48)}
          textAlign="center"
        >
          {source.title} Summary
        </PrimaryButton>
      </Link>

      <Flex
        flexDir={{ base: 'column', md: 'row' }}
        w="100%"
        position="relative"
        gridGap={GAP_SIZE_REM}
        pb={GAP_SIZE_REM}
      >
        {relatedPosts.same_source_articles.map((post, index) => {
          return isMobileView ? (
            <SourceCollapsedLarge
              key={`source-card-${index}`}
              source={normalizeSource(post)}
              headingSize="h4"
              titleOverride={`${
                post.user_data?.first_name + ' ' + post.user_data?.last_name
              }'s Key Ideas from ${post.title}`}
            />
          ) : (
            <SourceCollapsedMedium
              headingSize="h4"
              key={`source-card-${index}`}
              source={normalizeSource(post)}
              titleOverride={`${
                post.user_data?.first_name + ' ' + post.user_data?.last_name
              }'s Key Ideas from ${post.title}`}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};

export default OtherTakesList;
